<template>
	<section class="section">
		<form id="login" class="container">
			<div class="field">
				<input class="input" type="text" placeholder="Username" v-model="username">
			</div>
			<div class="field">
				<p class="control has-icons-left">
					<input class="input" type="password" placeholder="Password" v-model="password">
					<span class="icon is-small is-left">
						<i class="fas fa-lock"></i>
					</span>
				</p>
			</div>
			<a class="button is-success" v-on:click="login">Login</a>
		</form>
		<!--p><pre>data: {{ $data }}</pre></p-->
	</section>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		props: ['cat'],
		components: {
		},
		data: function () {
			return {
				username: "",
				password: "",
				error: false,
				neterr: false,
			}
		},
		methods: {
			login: function() {
				var vm = this

				vm.error = false
				vm.neterr = false

				db.logIn( vm.username, vm.password, function( err, response ) {
					if( err ) {
						if( err.name === 'unauthorized' || err.name === 'forbidden' ) {
							vm.error = true
						} else {
							vm.neterr = true
						}
						alert( err.message )
						console.log( err )
					} else {
						console.log( response )
						vm.$router.push('/')
						vm.$emit('login')
					}
				})
			}
		}
	}
</script>
